<template>
    <div class="entrust">
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="less" scoped>
.entrust{
    width: 100%;
    min-height: 100vh;
    background-color: #fff;
}
</style>